import { useEffect } from "react";
import { connect } from "react-redux";
import queryString from "query-string";
import { Search, Pagination } from "expano-components";
import { Main, PageLoader, Dashboard } from "components";

import { getPlatformTaxons } from "actions/platform_taxons";

import { ReactComponent as CategoryIcon } from "icons/category.svg";

import Tree from "./components/Tree";

const available_platforms = [
  "Spree::Platform",
  "Ebay::Platform",
  "Allegro::Platform",
  "Amazon::Platform",
  "Wsf::Platform",
  "Shoplo::Platform",
  "Emag::Platform",
];

const getHead = (platform_type) => {
  switch (platform_type) {
    case "Amazon::Platform":
      return ["Nazwa", "Typ produktu amazon"];
    default:
      return ["Nazwa"];
  }
};

const getRowData = (platform_type) => {
  switch (platform_type) {
    case "Amazon::Platform":
      return ["amazon_product_type_definitions"];
    default:
      return [];
  }
};

const CategoryTaxons = ({
  location,
  match: {
    params: { platform_id },
  },
  history,
  platform_taxons,
  getPlatformTaxons,
}) => {
  const { q, page, per_page } = queryString.parse(location.search);

  useEffect(() => {
    getPlatformTaxons({
      id: platform_id,
      page,
      per_page,
      q,
    });
  }, [platform_id, location.search]);

  const updateSearch = (page, per_page, q) =>
    history.push(
      `?${queryString.stringify({
        page: undefined,
        per_page: undefined,
        q,
      })}`
    );

  if (["invalid", "loading", "failure"].includes(platform_taxons.status)) {
    return <PageLoader />;
  }

  const {
    data: { platform, taxons },
    meta,
  } = platform_taxons;

  return (
    <Main
      page={{
        name: platform?.name,
        icon: <CategoryIcon />,
        breadcrumbs: [
          {
            name: "Kategorie platform",
            path: "/platforms/platform_taxons",
          },
          { name: platform?.name },
        ],
      }}
    >
      <Dashboard>
        <Search defaultValue={q} action={updateSearch} />
        {available_platforms.includes(platform_taxons.data?.platform?.type) ? (
          <>
            <Tree
              head={getHead(platform_taxons.data?.platform?.type)}
              data={taxons}
              row_data={getRowData(platform_taxons.data?.platform?.type)}
            />
            <Pagination
              data={{ ...meta, query: q }}
              history={history}
              location={location}
              handlePaginate={() => null}
            />
          </>
        ) : (
          <p style={{ padding: "0 30px" }}>Niezidentyfikowana platforma</p>
        )}
      </Dashboard>
    </Main>
  );
};

export default connect(
  ({ platform_taxons }) => ({
    platform_taxons,
  }),
  (dispatch) => ({
    getPlatformTaxons: (data) => dispatch(getPlatformTaxons(data)),
  })
)(CategoryTaxons);
